export const ar = {
  claimMyBonus: 'احصل على البونص الآن',
  copyright: 'حقوق النشر © 2025. Tauro Markets. جميع الحقوق محفوظة.',
  depositMinimum: 'قم بإيداع حد أدنى 200 دولار في حساب MT5 الكلاسيكي الخاص بك',
  downloadMt5: 'تحميل منصة MT5',
  enjoyTight:
    'استمتع بفروقات أسعار ضيقة تمنحك قيمة أكبر في كل صفقة، عبر أزواج الفوركس والمعادن الرئيسية.',
  forComplaints: 'لأي شكاوى، يرجى مراسلتنا عبر البريد الإلكتروني على',
  fsc: 'الجهة التنظيمية',
  fullyLicensed: 'Tauro Markets هي شركة مرخصة ومنظمة بالكامل من قبل الجهات التنظيمية في موريشيوس.',
  get50Bonus: 'احصل على بونص 50٪ فورًا',
  here: 'هنا',
  heroBlackHeader: 'ضاعف فرصك مع',
  heroRedHeader: 'بونص إيداع 50٪',
  heroSubheader: 'ابدأ التداول بقوة إضافية على MT5. أودع 200 دولار أو أكثر واحصل على',
  heroSubheaderBold: 'بونص يصل إلى 750 دولار',
  langName: 'العربية',
  mauritius: 'موريشيوس',
  mt5: 'منصة MT5 بأدوات متقدمة',
  multilingualSupport: 'دعم بلغات متعددة على مدار 24/5',
  okay: 'حسنًا',
  ourGlobalSupportTeam: 'فريق الدعم العالمي متاح 24/5 لمساعدتك بلغتك. سريع، واضح واحترافي.',
  pleaseReview: 'يرجى مراجعة سياسات الشركة والوثائق القانونية',
  receive50Deposit: 'احصل على 50٪ من مبلغ الإيداع، حتى 750 دولار كحد أقصى، كأموال بونص',
  registerAndClaim: 'سجل واحصل على البونص الآن',
  registerAndFund: 'سجل ومول حسابك',
  registerToday: 'سجل اليوم لتداول الأسواق المالية مع منتجات وخدمات عالمية المستوى.',
  regulatedBy: 'خاضعة للتنظيم',
  regulatedByFooter: 'تنظيم من قبل',
  riskHead1: 'تحذير من المخاطر',
  riskHead2: 'معلومات قانونية',
  riskHead3: 'ولايات قضائية محظورة',
  riskPara1:
    'ينطوي التداول بالرافعة المالية في عقود العملات الأجنبية أو العقود مقابل الفروقات أو المنتجات الأخرى خارج البورصة على مستوى عالٍ من المخاطر وقد لا يكون مناسبًا للجميع. قبل التداول، ننصح بشدة بقراءة وفهم إفصاحات المخاطر ذات الصلة. هناك احتمال كبير أن تخسر كامل استثمارك الأولي. يرجى التفكير في مدى ملاءمة هذه المنتجات لك حسب ظروفك الشخصية. نوصي بالحصول على استشارة مالية مستقلة والتأكد من أنك تفهم جميع المخاطر قبل التداول.',
  riskPara2:
    'Tauro Markets هي علامة تجارية مسجلة في موريشيوس من قبل Inno Net Solutions. الموقع مملوك لشركة Inno Net Solutions (رقم التسجيل: 208180) وهي شركة مرخصة ومنظمة. العنوان المسجل: Rue de la Democratie، CO AllServ Management Ltd، مكتب 306، الطابق الثالث، Ebene Junction، Ebene، 72201 موريشيوس. العنوان الفعلي: مكتب رقم 101، مكاتب Palm Court، الطابق الأول، 90 شارع سانت جان، Quatre Bornes، موريشيوس.',
  riskPara3:
    'نحن لا ننشئ حسابات للمقيمين في بعض الولايات القضائية بما في ذلك بلجيكا، جمهورية الكونغو الديمقراطية، إريتريا، إيران، كوريا الشمالية، ليبيا، الصومال، السودان، إسرائيل، موريشيوس، الولايات المتحدة (والأشخاص الخاضعين للتقارير الأمريكية) أو أي دولة يكون فيها التوزيع أو الاستخدام مخالفًا للقانون المحلي أو اللوائح.',
  spreads: 'فروقات أسعار تنافسية',
  startTrading: 'ابدأ التداول واسحب أرباحك',
  stepsHeader: 'احصل على البونص الخاص بك خلال',
  stepsHeaderRed: '3 خطوات بسيطة',
  tauroMarkets: 'Tauro Markets',
  tcHead1: '1. الأهلية',
  tcHead2: '2. المطالبة ببونص الإيداع',
  tcHead3: '3. متطلبات حجم التداول',
  tcHead4: '4. شروط السحب',
  tcHead5: '5. شروط إضافية',
  tcMainHeader: 'الشروط والأحكام العامة لبونص الإيداع',
  tcMainIntro:
    'تنطبق هذه الشروط والأحكام على عرض بونص الإيداع المقدم من Tauro Markets وهي متاحة للعملاء في عدد محدود من الدول. يُنصح العملاء بالتواصل مع الدعم لمعرفة تفاصيل الحملات وتوافرها.',
  tcPara11:
    '1.1. عرض بونص الإيداع متاح حصريًا للعملاء الذين يتداولون على منصة MetaTrader 5 (MT5) وينطبق فقط على الحسابات الكلاسيكية.',
  tcPara12:
    '1.2. هذا العرض متاح للعملاء الجدد والحاليين لدى Tauro Markets الذين يمتلكون حساب تداول مباشر نشط.',
  tcPara13: '1.3. للمشاركة، يجب على العملاء إجراء إيداع مؤهل في حساباتهم.',
  tcPara14: '1.4. بونص الإيداع لمرة واحدة بنسبة 50٪ من مبلغ الإيداع، بحد أقصى 750 دولار لكل عميل.',
  tcPara21:
    '2.1. الحد الأدنى للإيداع المطلوب للمطالبة بالبونص هو 200 دولار (ولا تُحتسب التحويلات الداخلية).',
  tcPara31:
    '3.1. لسحب أو تحويل البونص، يجب على العميل إتمام حجم تداول لا يقل عن 2.5 لوت قياسي لكل 5 دولارات من البونص.',
  tcPara32:
    '3.2. حتى يتم تحقيق متطلبات حجم التداول، يجب أن يظل رصيد الحساب والهامش المتاح مساويًا أو أكبر من مجموع الإيداع الأصلي والبونص.',
  tcPara33:
    '3.3. يتم احتساب حجم التداول فقط من أزواج العملات والمعادن. لا يتم احتساب العقود مقابل الفروقات، المؤشرات، USOIL والعملات الرقمية.',
  tcPara41:
    '4.1. لا يمكن سحب أي جزء من البونص إلا إذا تم استيفاء متطلبات حجم التداول الكامل كما هو موضح في البند 3.1.',
  tcPara42:
    '4.2. العملاء الذين لا يستوفون متطلبات حجم التداول ويرغبون في سحب أموالهم الأصلية يجب أن يضمنوا بقاء رصيد الحساب والهامش كافيًا، كما هو موضح في البند 3.2.',
  tcPara51:
    '5.1. تحتفظ Tauro Markets بالحق في تعديل أو تعليق أو إنهاء عرض البونص في أي وقت دون إشعار مسبق.',
  tcPara52:
    '5.2. في حالة الاشتباه في إساءة الاستخدام أو الاحتيال أو خرق شروط البونص، تحتفظ Tauro Markets بالحق في إلغاء البونص والأرباح المرتبطة به.',
  tcPara53:
    '5.3. من خلال المشاركة في هذا العرض، يوافق العملاء على جميع الشروط والأحكام الواردة هنا، بالإضافة إلى الشروط العامة للخدمة وشروط التداول لدى Tauro Markets.',
  tcFinal: 'لأي استفسارات أو توضيحات، يرجى التواصل مع دعم العملاء.',
  tradeSmarter: 'تداول بذكاء مع MT5، منصتنا القوية والبديهية المحسّنة لجميع أجهزتك.',
  trade25: 'تداول 2.5 لوت قياسي لكل 5 دولارات من البونص لتحريره. صالح للفوركس والمعادن فقط.',
  warning:
    'Tauro Markets هي منصة استثمار متعددة الأصول. قد تزيد أو تنخفض قيمة استثماراتك. رأس المال الخاص بك في خطر.',
  whyChoose: 'لماذا تختار',
}
